import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router";
import styles from "./Cta.module.css";

type Variant = "primary" | "secondary";

interface BaseProps {
  children: ReactNode;
  variant?: Variant;
  className?: string;
}

type ButtonProps = BaseProps &
  ButtonHTMLAttributes<HTMLButtonElement> & { to?: never };

type LinkProps = BaseProps & {
  /** Internal route. External URLs should use a plain anchor. */
  to: string;
};

function classesFor(variant: Variant, className?: string) {
  return [styles.cta, variant === "secondary" && styles.secondary, className]
    .filter(Boolean)
    .join(" ");
}

/** §07 CTA: cyan on ink, square, ice on hover with ink text throughout. */
export function Cta(props: ButtonProps | LinkProps) {
  if ("to" in props && props.to !== undefined) {
    const { children, variant = "primary", className, to } = props;
    return (
      <Link to={to} className={classesFor(variant, className)}>
        {children}
      </Link>
    );
  }

  const { children, variant = "primary", className, ...rest } = props as ButtonProps;
  return (
    <button type="button" className={classesFor(variant, className)} {...rest}>
      {children}
    </button>
  );
}
